// extracted by mini-css-extract-plugin
module.exports = {"GovUserClassificationsCard":"GovUserClassificationsCard_GovUserClassificationsCard__2a3xd","classificationBadge":"GovUserClassificationsCard_classificationBadge__339ev"};